<form novalidate #currentForm="ngForm">
  <div class="endpoints-container">
    <div class="section-container">
      <div class="section-label">Endpoints</div>
      <div class="endpoint-section">
        <nrwl-agent-picker
          [testType]="'rfc2544'"
          [originatorDevice]="selectedOriginator"
          [destinationDevice]="selectedDestination"
          [editMode]="editMode"
          [testMode]="testMode"
          [loopbackType]="selectedLoopbackTypes"
          [showTestMode]="false"
          (emitAgents)="onAgentChange($event)"
        ></nrwl-agent-picker>
        <div class="agent-info">
          <div class="orginator-info">
            <div class="orginator-content" *ngIf="showOrginatorDetails">
              <div class="section-data"></div>
              <div class="section-data" *ngIf="showFormField(configMapping.SRC_TEST_IP_ADDRESS)">
                <div class="group">
                  <div class="label">IP address *</div>
                  <input
                    matInput
                    autocomplete="off"
                    type="text"
                    name="srcIpAddress"
                    class="width-200"
                    [(ngModel)]="formField.srcIpAddress"
                    #srcIpAddressInput="ngModel"
                    (ngModelChange)="onSourceIpAddressChange()"
                    [pattern]="validIPRegex"
                    required
                  />
                  <div
                    class="error"
                    *ngIf="
                      srcIpAddressInput.invalid &&
                      (srcIpAddressInput.dirty || srcIpAddressInput.touched)
                    "
                  >
                    <mat-error *ngIf="srcIpAddressInput?.errors?.required"> Required</mat-error>
                    <mat-error *ngIf="srcIpAddressInput.errors?.pattern">{{
                      ipErrorMsg
                    }}</mat-error>
                  </div>
                </div>
              </div>
              <div
                class="section-data"
                *ngIf="showFormField(configMapping.SRC_SUBNET) && layer3Enabled"
              >
                <div class="group">
                  <div class="label">Subnet mask/prefix *</div>
                  <input
                    matInput
                    autocomplete="off"
                    type="text"
                    name="srcSubnet"
                    [(ngModel)]="formField.srcSubnet"
                    #srcSubnetInput="ngModel"
                    [disabled]="!formField.srcEditLayer3Subnet"
                    [ngClass]="{
                      disable: !formField.srcEditLayer3Subnet
                    }"
                    (ngModelChange)="onSourceSubnetChange()"
                    [pattern]="subnetRegEx"
                    required
                  />
                  <div
                    class="error"
                    *ngIf="
                      srcSubnetInput.invalid && (srcSubnetInput.dirty || srcSubnetInput.touched)
                    "
                  >
                    <mat-error *ngIf="srcSubnetInput?.errors?.required"> Required</mat-error>
                    <mat-error *ngIf="srcSubnetInput.errors?.pattern"
                      >Subnet is not valid</mat-error
                    >
                  </div>
                </div>
                <div
                  class="group"
                  *ngIf="showFormField(configMapping.SRC_GATEWAY) && layer3Enabled"
                >
                  <div class="label">Gateway address *</div>
                  <input
                    matInput
                    autocomplete="off"
                    type="text"
                    name="srcGateway"
                    [(ngModel)]="formField.srcGateway"
                    #srcGatewayInput="ngModel"
                    [disabled]="!formField.srcEditLayer3Subnet"
                    [ngClass]="{
                      disable: !formField.srcEditLayer3Subnet
                    }"
                    (ngModelChange)="onSourceGatewayChange()"
                    [pattern]="validIPRegex"
                    required
                  />
                  <div
                    class="error"
                    *ngIf="
                      srcGatewayInput.invalid && (srcGatewayInput.dirty || srcGatewayInput.touched)
                    "
                  >
                    <mat-error *ngIf="srcGatewayInput?.errors?.required"> Required</mat-error>
                    <mat-error *ngIf="srcGatewayInput.errors?.pattern"
                      >Gateway must be set to a valid address</mat-error
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="destination-info" *ngIf="showDestinationDetails">
            <div class="section-data">
              <div class="group" *ngIf="layer2Enabled && isJmepAsLb">
                <div class="label">Transmit interface</div>
                <mat-select
                  class="option-list"
                  #destTxInterfaceInput="ngModel"
                  [(ngModel)]="formField.destTxInterface"
                  name="destTxInterface"
                  (selectionChange)="onDestTxInterfaceChange()"
                  required
                >
                  <mat-option *ngFor="let tx of txInterfaceTypes" [value]="tx.value">{{
                    tx.name
                  }}</mat-option>
                </mat-select>
              </div>
              <div class="tx-image" *ngIf="layer2Enabled && isJmepAsLb">
                <img [src]="destTxTypeImage" />
              </div>
              <div class="group" *ngIf="layer3Enabled ? this.formField.destShowMacLayer3 : true">
                <div class="label">MAC address *</div>
                <input
                  matInput
                  autocomplete="off"
                  type="text"
                  name="destMacAddress"
                  [(ngModel)]="formField.destMacAddress"
                  #destMacAddressInput="ngModel"
                  (ngModelChange)="onDestinationMacAddressChange()"
                  [pattern]="macRegex"
                  required
                />
                <div
                  class="error"
                  *ngIf="
                    destMacAddressInput.invalid &&
                    (destMacAddressInput.dirty || destMacAddressInput.touched)
                  "
                >
                  <mat-error *ngIf="destMacAddressInput?.errors?.required"> Required</mat-error>
                  <mat-error *ngIf="destMacAddressInput.errors?.pattern"
                    >Mac Address is not a valid</mat-error
                  >
                </div>
              </div>
            </div>
            <div
              class="section-data"
              *ngIf="((layer2Enabled ? this.formField.destShowIpLayer2 : true) || (layer3Enabled && isJmepAsLb))"
            >
            <div class="group" *ngIf="isJmepAsLb">
              <div class="label">Defined address using</div>
              <mat-select class="option-list"
                #destDefinedAddressInput="ngModel"
                [(ngModel)]="formField.destDefinedAddress"
                name="destDefinedAddress"
                (selectionChange)="onDestDefinedAddressChange()" required>
                <ng-container *ngFor="let type of destDefinedAddressTypes">
                  <mat-option *ngIf="type.enabled" [value]="type.value">{{
                    type.name
                    }}</mat-option>
                </ng-container>
              </mat-select>
            </div>
              <div class="group">
                <div class="label">IP address *</div>
                <input
                  matInput
                  autocomplete="off"
                  type="text"
                  class="width-200"
                  name="destIpAddress"
                  [(ngModel)]="formField.destIpAddress"
                  #destIpAddressInput="ngModel"
                  (ngModelChange)="onDestinationIpAddressChange()"
                  [pattern]="validIPRegex"
                  required
                />
                <div
                  class="error"
                  *ngIf="
                    destIpAddressInput.invalid &&
                    (destIpAddressInput.dirty || destIpAddressInput.touched)
                  "
                >
                  <mat-error *ngIf="destIpAddressInput?.errors?.required"> Required</mat-error>
                  <mat-error *ngIf="destIpAddressInput.errors?.pattern">{{ ipErrorMsg }}</mat-error>
                </div>
              </div>
            </div>
            <div class="section-data">
              <div class="group" *ngIf="showFormField(configMapping.SUPPRESS_LOOP_COMMANDS)">
                <div class="label">Loop up device</div>
                <mat-select
                  class="option-list width-75"
                  #supressLoopIntervalInput="ngModel"
                  [(ngModel)]="formField.suppressLoop"
                  name="suppressLoop"
                  (selectionChange)="onSuppressLoopChange()"
                  required
                >
                  <mat-option *ngFor="let supress of suppressLoopTypes" [value]="supress.value">{{
                    supress.name
                  }}</mat-option>
                </mat-select>
              </div>
            </div>
          </div>
          <div class="setup-manual" *ngIf="!showDestinationDetails && testMode === 'loopback'">
            <a href="#" (click)="setManualDestAddress($event)">Setup manually</a>
          </div>
        </div>
      </div>
    </div>
    <div class="section-container" *ngIf="showFormField(configMapping.VLAN_CONFIG)">
      <div class="section-label">VLAN</div>
      <div class="section-data">
        <div class="group">
          <div class="label">VLAN Config</div>
          <mat-select
            class="option-list"
            #vlanConfigInput="ngModel"
            [(ngModel)]="formField.vlanConfig"
            name="vlanConfig"
            (selectionChange)="onVlanConfigChange()"
            required
          >
            <mat-option *ngFor="let vlan of vlanConfigTypes" [value]="vlan.value">{{
              vlan.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group" *ngIf="formField.vlanConfig !== 'untagged'">
          <div class="label">{{ formField.vlanConfig === 'q_in_q' ? 'S-VLAN *' : 'VLAN *' }}</div>
          <input
            matInput
            autocomplete="off"
            type="number"
            name="svlan"
            class="width-75"
            [(ngModel)]="formField.svlan"
            #sVlanInput="ngModel"
            (ngModelChange)="onSVlanChange()"
            min="1"
            max="4094"
            required
          />
          <div class="error" *ngIf="sVlanInput.invalid && (sVlanInput.dirty || sVlanInput.touched)">
            <mat-error *ngIf="sVlanInput.errors.required">Required</mat-error>
            <mat-error *ngIf="sVlanInput.errors?.min || sVlanInput.errors?.max"
              >Should be 1 to 4094</mat-error
            >
          </div>
        </div>
        <div class="group" *ngIf="formField.vlanConfig !== 'untagged'">
          <div class="label">
            {{ formField.vlanConfig === 'q_in_q' ? 'S-VLAN Priority *' : 'VLAN Priority *' }}
          </div>
          <input
            matInput
            autocomplete="off"
            type="number"
            name="svlanPriority"
            class="width-75"
            [(ngModel)]="formField.svlanPriority"
            #sVlanPriorityInput="ngModel"
            (ngModelChange)="onSVlanPriorityChange()"
            min="0"
            max="7"
            required
          />
          <div
            class="error"
            *ngIf="
              sVlanPriorityInput.invalid && (sVlanPriorityInput.dirty || sVlanPriorityInput.touched)
            "
          >
            <mat-error *ngIf="sVlanPriorityInput.errors.required">Required</mat-error>
            <mat-error *ngIf="sVlanPriorityInput.errors?.min || sVlanPriorityInput.errors?.max"
              >Should be 0 to 7</mat-error
            >
          </div>
        </div>
        <div
          class="group"
          *ngIf="showFormField(configMapping.ETHER_TYPE) && formField.vlanConfig !== 'untagged'"
        >
          <div class="label">Ethertype</div>
          <mat-select
            class="option-list width-75"
            #etherTypeInput="ngModel"
            [(ngModel)]="formField.etherType"
            name="etherType"
            (selectionChange)="onEtherTypeChange()"
            required
          >
            <mat-option *ngFor="let ether of etherTypesData" [value]="ether.value">{{
              ether.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group" *ngIf="formField.vlanConfig === 'q_in_q'">
          <div class="label">C-VLAN *</div>
          <input
            matInput
            autocomplete="off"
            type="number"
            name="cvlan"
            class="width-75"
            [(ngModel)]="formField.cvlan"
            #cVlanInput="ngModel"
            (ngModelChange)="onCVlanChange()"
            min="1"
            max="4094"
            required
          />
          <div class="error" *ngIf="cVlanInput.invalid && (cVlanInput.dirty || cVlanInput.touched)">
            <mat-error *ngIf="cVlanInput.errors?.required">Required</mat-error>
            <mat-error *ngIf="cVlanInput.errors?.min || cVlanInput.errors?.max"
              >Should be 1 to 4094</mat-error
            >
          </div>
        </div>
        <div class="group" *ngIf="formField.vlanConfig === 'q_in_q'">
          <div class="label">C-VLAN Priority</div>
          <input
            matInput
            autocomplete="off"
            type="number"
            name="cvlanPriority"
            class="width-75"
            [(ngModel)]="formField.cvlanPriority"
            #cVlanPriorityInput="ngModel"
            (ngModelChange)="onCVlanPriorityChange()"
            min="0"
            max="7"
            required
          />
          <div
            class="error"
            *ngIf="
              cVlanPriorityInput.invalid && (cVlanPriorityInput.dirty || cVlanPriorityInput.touched)
            "
          >
            <mat-error *ngIf="cVlanPriorityInput.errors.required">Required</mat-error>
            <mat-error *ngIf="cVlanPriorityInput.errors?.min || cVlanPriorityInput.errors?.max"
              >Should be 0 to 7</mat-error
            >
          </div>
        </div>
      </div>
    </div>
    <div class="section-container">
      <div class="section-label"></div>
      <div class="section-data">
        <div class="group" *ngIf="showFormField(configMapping.REMOTE_VLAN_TAG)">
          <div class="label width-140">Remote VLAN Tag Count</div>
          <mat-select
            class="option-list"
            #remoteVlanInput="ngModel"
            [(ngModel)]="formField.remoteVlan"
            name="remoteVlan"
            (selectionChange)="onRemoteVlanChange()"
            required
          >
            <mat-option *ngFor="let vlan of remoteVlanData" [value]="vlan.value">{{
              vlan.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group">
          <div class="label width-140">Verify VLAN Priority</div>
          <mat-select
            class="option-list width-75"
            #verifyVlanInput="ngModel"
            [(ngModel)]="formField.vlanPriority"
            [disabled]="formField.vlanConfig === 'untagged'"
            [ngClass]="{
              disable: formField.vlanConfig === 'untagged'
            }"
            name="verifyVlan"
            (selectionChange)="onVlanPriorityChange()"
            required
          >
            <mat-option *ngFor="let vlan of verifyVlanData" [value]="vlan.value">{{
              vlan.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group">
          <div class="label">Network overhead</div>
          <input
            matInput
            autocomplete="off"
            type="number"
            class="input-data width-75 float-left"
            name="networkOverhead"
            #networkOverheadInput="ngModel"
            [(ngModel)]="formField.networkOverhead"
            (ngModelChange)="networkOverheadChange()"
            min="0"
            max="255"
            required
          />
          <div
            class="error clr-float"
            *ngIf="
              networkOverheadInput.invalid &&
              (networkOverheadInput.dirty || networkOverheadInput.touched)
            "
          >
            <mat-error *ngIf="networkOverheadInput?.errors?.required"
              >Network overhead is required</mat-error
            >
            <mat-error *ngIf="networkOverheadInput.errors?.min || networkOverheadInput.errors?.max">
              Value should be 0 to 255</mat-error
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
